import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { GithubOutlined, WechatOutlined, QqOutlined } from '@ant-design/icons';
import './index.css';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;


const AppFooter = () => {
    return ( 
        <AntFooter className="app-footer">
            <Text>Copyright © 2025</Text>
            <Space size="large" className="social-links">
                <Link href="https://github.com/yangxiaoge" target="_blank" title="Github">
                    <GithubOutlined style={{ fontSize: '24px', color: 'rgba(39, 39, 39, 0.5)' }} />
                </Link>
                <Link href="https://wx.qq.com/?lang=zh_CN" target="_blank" title="微信">
                    <WechatOutlined style={{ fontSize: '24px', color: 'rgba(39, 39, 39, 0.5)' }} />
                </Link>
                <Link href="https://wx.qq.com/?lang=zh_CN" target="_blank" title="QQ">
                    <QqOutlined style={{ fontSize: '24px', color: 'rgba(39, 39, 39, 0.5)' }} />
                </Link>
             </Space>
             <Text>Powered by React & Ant Design</Text>
        </AntFooter>
    );
}

export default AppFooter;